import { ApplicationState } from '../../../../store/types';
import { getRegistrationRoot } from '../../store/selectors';
import { RegistrationDetails } from './types';

export const getRegistrationDetails = (state: ApplicationState): RegistrationDetails => getRegistrationRoot(state).registrationDetails;

export const getEmailValid = (state: ApplicationState): boolean => getRegistrationRoot(state).emailValid;
